'use strict'

const editLink = '<a href="" class="btn btn-primary editItem"><span class="glyphicon glyphicon-pencil"></span></a>'
const deleteLink = '<a href="" class="btn btn-danger removeItem"><span class="glyphicons glyphicons-bin"></span></a>'

const smEditLink = '<a href="" class="btn btn-xs btn-primary editItem"><span class="glyphicons glyphicons-pencil"></span> Edit</a>'
const smDeleteLink = '<a href="" class="btn btn-xs btn-danger removeItem"><span class="glyphicons glyphicons-bin"></span> Delete</a>'

export const BUTTONS = {
  EDIT_LINK: editLink,
  DELETE_LINK: deleteLink,
  SMALL_EDIT_LINK: smEditLink,
  SMALL_DELETE_LINK: smDeleteLink
}



// WEBPACK FOOTER //
// ./src/js/common/Buttons.js